export const reactionTypeMap = new Map([
  [
    'helpful',
    {
      name: 'helpful',
      emojiUrl: 'https://ssl.pstatic.net/static/pup/reactiontype/helpful_44w.png',
      label: { en: 'helpful', ko: '도움돼요', ja: '役に立ちます' },
      isActive: true,
    },
  ],
  [
    'fun',
    {
      name: 'fun',
      emojiUrl: 'https://ssl.pstatic.net/static/pup/reactiontype/fun_44w.png',
      label: { en: 'fun', ko: '재밌어요', ja: '面白い' },
      isActive: true,
    },
  ],
  [
    'wannago',
    {
      name: 'wannago',
      emojiUrl: 'https://ssl.pstatic.net/static/pup/reactiontype/wannago_44w.png',
      label: { en: 'wannago', ko: '가고 싶어요', ja: '行きたいです' },
      isActive: true,
    },
  ],
  [
    'cool',
    {
      name: 'cool',
      emojiUrl: 'https://ssl.pstatic.net/static/pup/reactiontype/cool_44w.png',
      label: { en: 'cool', ko: '멋져요', ja: '素敵です' },
      isActive: true,
    },
  ],
])
